import React, { useEffect, useState } from 'react';
import NumberFormat, { FormatInputValueFunction, NumberFormatValues } from 'react-number-format';
import { useDispatch } from 'react-redux';
import { validate } from 'czech-personal-number';
import { registrationActions } from '../../store/registration/registration.reducer';
import { Input } from './Input';
import { Label } from './Label';
import { FormHelperText } from '@material-ui/core';
import { FormField } from './FormField';
import { RequestType } from '../../model/enums/RequestType';

type PersonalNumberFormFieldProps = {
  required: boolean;
  requestType?: RequestType;
  defaultValue: string;
}

const defaultFormat = '######/####';

export const PersonalNumberFormField = (props: PersonalNumberFormFieldProps) => {
  const dispatch = useDispatch();

  const [inputValue, setInputValue] = useState(props.defaultValue);
  const [className, setClassName] = useState<string>('');
  const [format, setFormat] = useState<string | FormatInputValueFunction>(defaultFormat);

  useEffect(() => {
    const isValid = inputValue.length === 0 || validate(inputValue).isValid;

    // Change input class
    setClassName(!isValid ? 'invalid' : '');

    // Set input format
    setFormat(() => inputValue.length === 9 ? (input: string) => `${input.slice(0, 6)}/${input.slice(6)}` : defaultFormat);

    // Set to patient if is valid
    dispatch(registrationActions.setPatient({ personalNumber: isValid ? inputValue : '' }));
  }, [inputValue, dispatch]);

  return <FormField>
    <Label required={props.required}>Rodné číslo:</Label>
    <NumberFormat value={inputValue}
                  onValueChange={(values: NumberFormatValues) => setInputValue(values.value)}
                  format={format}
                  className={className}
                  displayType={'input'}
                  customInput={Input}
                  mask={'_'}
                  allowEmptyFormatting={true} />
    <FormHelperText>
      {(() => {
        if (props.requestType === RequestType.DoctorRegistration) {
          return 'Zadejte rodné číslo pacienta ve formátu RRMMDD/ČČČ(Č)';
        } else {
          return 'Zadejte Vaše rodné číslo ve formátu RRMMDD/ČČČ(Č)';
        }
      })()}
    </FormHelperText>
  </FormField>;
};
